<template>
  <v-list-group v-if="hasChildren">
    <template #activator="{ props: gProps }">
      <v-list-item
        v-bind="gProps"
        rounded="lg"
        class="mb-1"
        :prepend-icon="itemPrependIcon"
        :title="displayTitle"
      />
    </template>
    <portal-sidebar-nav-group
      v-for="(ch, idx) in childItems"
      :key="childKey(ch, idx)"
      :item="ch"
      @nav="$emit('nav', $event)"
    />
  </v-list-group>
  <v-list-item
    v-else
    rounded="lg"
    class="mb-1"
    :prepend-icon="itemPrependIcon"
    :title="displayTitle"
    :active="isActiveRoute"
    @click="onLeafClick"
  />
</template>

<script>
import icons, { PORTAL_MODULE_MENU_ICONS } from "../../utils/enums/icons";
import { normalizePortalModulePath } from "../../utils/helpers/normalizePortalModulePath";

export default {
  name: "PortalSidebarNavGroup",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ["nav"],
  computed: {
    rawChildren() {
      return this.item.children ?? [];
    },
    hasChildren() {
      return Array.isArray(this.rawChildren) && this.rawChildren.length > 0;
    },
    childItems() {
      return this.hasChildren ? this.rawChildren : [];
    },
    displayTitle() {
      return this.item.title ?? "";
    },
    isActiveRoute() {
      const target = normalizePortalModulePath(
        this.item.path
      );
      return this.$route.path === target;
    },
    itemPrependIcon() {
      const raw = this.item.path ?? "";
      const k = String(raw).trim().replace(/^\/+/, "").toLowerCase();
      return PORTAL_MODULE_MENU_ICONS[k] ?? icons.VIEW_DASHBOARD;
    },
  },
  methods: {
    childKey(ch, idx) {
      return ch.id ?? ch.path ?? ch.title ?? `c-${idx}`;
    },
    onLeafClick() {
      this.$emit("nav", this.item);
    },
  },
};
</script>
